import { ArrowUp, Loader2 } from "lucide-react";

interface ReaderNextPullHintProps {
  active: boolean;
  progress: number;
  armed: boolean;
  firing: boolean;
  hasNext: boolean;
}

export function ReaderNextPullHint({
  active,
  progress,
  armed,
  firing,
  hasNext,
}: ReaderNextPullHintProps) {
  if (!active && !firing) return null;

  const boundedProgress = Math.min(1, Math.max(0, progress));
  const progressDegrees = `${Math.round(boundedProgress * 360)}deg`;
  const canTurnPage = hasNext && (armed || firing);
  const progressBackground = canTurnPage
    ? "currentColor"
    : `conic-gradient(currentColor ${progressDegrees}, transparent 0)`;

  return (
    <div className="pointer-events-none fixed inset-x-0 bottom-[calc(env(safe-area-inset-bottom)+4.5rem)] z-40 flex justify-center md:hidden">
      <div
        className={`grid size-12 place-items-center rounded-full p-1 shadow-[0_14px_36px_rgba(0,0,0,0.22)] backdrop-blur-xl transition duration-150 ${
          canTurnPage ? "scale-105 bg-foreground text-background" : "bg-background/82 text-foreground"
        }`}
        style={{
          background: progressBackground,
        }}
        aria-label={canTurnPage ? "松手进入下一章" : "继续上滑加载下一章"}
      >
        <div className={`grid size-10 place-items-center rounded-full ${canTurnPage ? "bg-foreground text-background" : "bg-background/92 text-foreground"}`}>
          {firing ? (
            <Loader2 className="size-4 animate-spin" />
          ) : (
            <ArrowUp className={`size-4 transition ${canTurnPage ? "-translate-y-0.5" : ""}`} />
          )}
        </div>
      </div>
    </div>
  );
}
